import { graphql } from "@acto/gql";
import type { ApiKeyScope } from "@acto/gql/graphql";
import { useCallback, useState } from "react";
import { useMutation } from "urql";

const GenerateApiKeyMutation = graphql(`
  mutation GenerateApiKey($input: GenerateApiKeyInput!) {
    generateApiKey(input: $input) {
      id
      name
      plainTextKey
      prefixHint
      scopes
      createdAt
    }
  }
`);

export function useGenerateApiKey() {
  const [result, generateApiKeyMutation] = useMutation(GenerateApiKeyMutation);
  const [error, setError] = useState<Error | null>(null);

  const generateApiKey = useCallback(
    async (input: { name: string; scopes: ApiKeyScope[] }) => {
      try {
        const response = await generateApiKeyMutation({ input });
        if (response.error) {
          console.error("unable to generate api key");
          setError(response.error);

          return null;
        }

        return response.data?.generateApiKey ?? null;
      } catch (err: unknown) {
        const error = err instanceof Error ? err : new Error("Failed to generate API key");
        console.error("unable to generate api key", error);
        setError(error);

        return null;
      }
    },
    [generateApiKeyMutation],
  );

  return { generateApiKey, result, error };
}
